// extracted by mini-css-extract-plugin
export var badge = "ds_jS";
export var caption = "ds_fc";
export var header = "ds_q";
export var headerWithHorizontalRule = "ds_jP";
export var v1 = "ds_jQ";
export var v2 = "ds_jR";